import Vue from 'vue';

const resource = '/importations';

export default {
  // CUSTOM ENDPOINT
  workOrdersImport(data) {
    return Vue.prototype.$axiosMainClient.post(`${resource}/workorders`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  itemsImport(data) {
    return Vue.prototype.$axiosMainClient.post(`${resource}/items`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};
